export const PHOTOS_LIST = ["BANNER_IMAGES"]